var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTooltip",
    {
      attrs: { arrow: false },
      scopedSlots: _vm._u([
        {
          key: "content",
          fn: function() {
            return [
              _c("span", [
                _vm._v(_vm._s(_vm.file.name + "." + _vm.file.extension))
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "email-attachment-link",
          class: _vm.classes,
          on: { click: _vm.handleClick }
        },
        [
          _c("svg", {
            staticClass: "file-icon",
            attrs: { viewBox: _vm.fileType.viewBox },
            domProps: { innerHTML: _vm._s(_vm.fileType.src) }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "email-attachment-link__label" }, [
            _vm._v(_vm._s(_vm.truncatedText))
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }